// extracted by mini-css-extract-plugin
export default {"language-switcher":"languageSwitcher_language-switcher__HDrdb","active":"languageSwitcher_active__A+Y6W"};